import { DashboardShell } from "@/components/dashboard-shell";
import { TasksBoard } from "@/components/tasks/tasks-board";
import { createFileRoute } from "@tanstack/react-router";
import {
  RouteLoading,
  ToolbarSkeleton,
  TasksLoadingSkeleton,
} from "@/components/route-loading";

export const Route = createFileRoute("/tasks")({
  component: TasksPage,
  head: () => ({ meta: [{ title: "Tasks" }] }),
  pendingComponent: TasksPending,
});

function TasksPage() {
  return (
    <DashboardShell>
      <TasksBoard />
    </DashboardShell>
  );
}

// Shown while this route's chunk (and the ReUI components in it)
// downloads. Was src/app/tasks/loading.tsx.
function TasksPending() {
  return (
    <RouteLoading>
      <ToolbarSkeleton />
      <TasksLoadingSkeleton />
    </RouteLoading>
  );
}
